<template>
  <footer class="global-box">
    <div class="content-box">
      <section class="content-footer">
        <div class="logotype">
          <img src="../assets/images/logo/logotype-click-gestao.svg" />
        </div>
        <div class="social">
          <section class="contact">
            <p>
              (31) 98266-9088
            </p>
            <p>
              atendimento@clickgestao.com.br
            </p>
          </section>
        </div>
      </section>
      <p class="full copy">
        © Copyright {{new Date().getFullYear()}} - Direitos reservados a Click Gestão
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'footer-session',
  props: {
  },
  data() {
    return {
    };
  },
  methods: {
  },
};
</script>

<style lang="sass" scoped>
  @import "../assets/sass/main.sass"
  footer
    width: 100%
    position: relative
    &.global-box
      padding: 12% 0 0
      overflow: hidden
      .content-box
        position: relative
        .content-footer
          width: 100%
          height: 80%
          display: flex
          flex-wrap: wrap
          justify-content: space-between
          .social
            width: 100%
            margin-top: 32px
            text-align: center
          .logotype
            width: 100%
            text-align: center
            img
              opacity: .2
              max-width: 100px
        .copy
          text-align: center
          font-size: 16px
          color: $white
          margin: 20px 0
          font-weight: 300
    &::before
      content: ''
      position: absolute
      top: 0
      right: 0
      width: 100%
      height: 1000px
      background: $background-secundary
      transform-origin: 100%
      transform: skewY(-12deg)
    @media (max-width: $widthTerciarySmall)
      &.global-box
        padding: 12% 0 0
        .content-box
          .content-footer
            .logotype
              img
                width: 20%
          .copy
            font-size: 14px
            margin-bottom: 88px
</style>
